import { Col, Row } from "antd";
import React from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ChartValueType, ScenarioFrontierFileType } from "../../../../../../constants/constants";
import { FileParsedModel } from "../../../../../../models/scenario-frontier.model";
import FrontierChart, { FrontierChartData } from "./chart";
import "./index.scss";

interface Props {
    year: number;
    data: FileParsedModel[];
}

const FrontierChartOutput = (props: Props) => {

    const { t } = useTranslation();
    const [rateStressData, setRateStressData] = useState<FrontierChartData[]>([]);
    const [rateStressLables, setRateStressLables] = useState<string[]>([]);

    const [LGDStressData, setLGDStressData] = useState<FrontierChartData[]>([]);
    const [LGDStressLables, setLGDStressLables] = useState<string[]>([]);

    const [creditRiskExposureData, setCreditRiskExposureData] = useState<FrontierChartData[]>([]);
    const [creditRiskRequiredCapitalData, setCreditRiskRequiredCapitalData] = useState<FrontierChartData[]>([]);
    const [creditRiskLables, setCreditRiskLables] = useState<string[]>([]);

    useEffect(() => {

        if (props.data) {

            const table1 = props.data.find(x => x.file_type === ScenarioFrontierFileType.SFSB_RESULT_1);

            if (table1) {
                const data = table1.file_data.filter(x => !!x.Segment);

                setRateStressLables(data.map(x => x.Segment));

                setRateStressData(
                    [{
                        label: table1.file_md.columns[2],
                        data: data.map(p => p[table1.file_md.columns[2]] * 100),
                        backgroundColor: "#5B80B8"
                    },
                    {
                        label: table1.file_md.columns[3],
                        data: data.map(p => p[table1.file_md.columns[3]] * 100),
                        backgroundColor: "#B25751"
                    },
                    {
                        label: table1.file_md.columns[4],
                        data: data.map(p => p[table1.file_md.columns[4]] * 100),
                        backgroundColor: "#A1BA66"
                    }]);
            }

            const table2 = props.data.find(x => x.file_type === ScenarioFrontierFileType.SFSB_RESULT_2);
            if (table2) {
                const data = table2.file_data.filter(x => !!x.Segment);

                setLGDStressLables(data.map(x => x.Segment));

                setLGDStressData(
                    [{
                        label: table2.file_md.columns[2],
                        data: data.map(p => p[table2.file_md.columns[2]] * 100),
                        backgroundColor: "#5B80B8"
                    },
                    {
                        label: table2.file_md.columns[3],
                        data: data.map(p => p[table2.file_md.columns[3]] * 100),
                        backgroundColor: "#B25751"
                    }]);
            }

            const table3 = props.data.find(x => x.file_type === ScenarioFrontierFileType.SFSB_RESULT_3);

            if (table3) {
                const data = table3.file_data.filter(x => !!x.Segment);

                setCreditRiskLables(data.map(x => x.Segment));

                setCreditRiskExposureData(
                    [{
                        label: table3.file_md.columns[2],
                        data: data.map(p => p[table3.file_md.columns[2]]),
                        backgroundColor: "#5B80B8"
                    },
                    {
                        label: table3.file_md.columns[4],
                        data: data.map(p => p[table3.file_md.columns[4]]),
                        backgroundColor: "#B25751"
                    },
                    {
                        label: table3.file_md.columns[6],
                        data: data.map(p => p[table3.file_md.columns[6]]),
                        backgroundColor: "#A1BA66"
                    }]
                );

                setCreditRiskRequiredCapitalData(
                    [{
                        label: table3.file_md.columns[3],
                        data: data.map(p => p[table3.file_md.columns[3]]),
                        backgroundColor: "#5B80B8"
                    },
                    {
                        label: table3.file_md.columns[5],
                        data: data.map(p => p[table3.file_md.columns[5]]),
                        backgroundColor: "#B25751"
                    },
                    {
                        label: table3.file_md.columns[7],
                        data: data.map(p => p[table3.file_md.columns[7]]),
                        backgroundColor: "#A1BA66"
                    }]
                );
            }

        }
    }, [props.data])

    return (
        <div className="frontier-output-chart-wrapper">

            <Row>
                <Col span={24}>
                    <FrontierChart
                        title={t("ScenarioFrontier.lbDefaultRateStressTesting")}
                        data={rateStressData}
                        labels={rateStressLables}
                        chartId="frontierChart1"
                        valueType={ChartValueType.Percent} />
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <FrontierChart
                        title={t("ScenarioFrontier.lbLGDStressTesting")}
                        data={LGDStressData}
                        labels={LGDStressLables}
                        chartId="frontierChart2"
                        valueType={ChartValueType.Percent} />
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <FrontierChart
                        title={t("ScenarioFrontier.lbCreditRiskExposure")}
                        data={creditRiskExposureData}
                        labels={creditRiskLables}
                        chartId="frontierChart3"
                        valueType={ChartValueType.Currency} />
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <FrontierChart
                        title={t("ScenarioFrontier.lbCreditRiskRequiredCapital")}
                        data={creditRiskRequiredCapitalData}
                        labels={creditRiskLables}
                        chartId="frontierChart4"
                        valueType={ChartValueType.Currency} />
                </Col>
            </Row>


        </div>
    );

}

export default FrontierChartOutput;